import { useEffect, useState } from "react";
import { Route, Routes,useNavigate} from "react-router-dom";
import StepSliderContainer from "../views/StepSlider/StepSliderContainer";
import { FluentProvider, teamsDarkTheme } from "@fluentui/react-components";
import ImageGenerator from "../views/ImageGenerator";
import UserImages from "../views/UserImages";
import { GenerateImageProvider } from "../context/GenerateImageContext";
import { UserImageProvider } from "../context/UserImageContext";
import HomePage from "../views/HomePage";
import useSteps from "../hooks/useSteps";
import ReactGA from "react-ga4";
import { AuthProvider } from "../context/AuthContext";
import "./App.css";

const Pages = () => {
  const { steps } = useSteps();
  const [showHomePage, setShowHomePage] = useState(true);
  const navigate = useNavigate();
  const TRACKING_ID = "UA-37782555-1";
  ReactGA.initialize(TRACKING_ID);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowHomePage(false);
    }, 4500);
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

 

  

 

  return (
    <GenerateImageProvider>
      <AuthProvider>
        <UserImageProvider>
          <Routes>
            {showHomePage ? (
              <Route exact path="/" element={<HomePage />} />
            ) : (
              <>
                <Route exact path="/generate" element={<ImageGenerator />} />
                <Route path="/gallery" element={<UserImages />} />
                <Route
                  path="/"
                  element={<StepSliderContainer steps={steps} />}
                />
              </>
            )}
          </Routes>
        </UserImageProvider>
      </AuthProvider>
    </GenerateImageProvider>
  );
};

const App = () => {
  return (
    <div className="App">
      <FluentProvider theme={teamsDarkTheme}>
          <Pages />
      </FluentProvider>
    </div>
  );
};
export default App;
